module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/th_tohoku-aec27fd23a32df03c6c5ba0c1a78516a.jpg";